import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import useInput from "../Assets/UseInput";
import {useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

var serialize = require('serialize-javascript');

function Job (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const next = () =>{
        let hasPartner  = localStorage.getItem("hasActivePartner") === 'true'
        let nextLocation = {}
        if (checkbox.employe || checkbox.ouvrier || checkbox.fonctionnaire){
            nextLocation = {
                pathname: '../job-employee',
                state: { d: d }
            }
        }else if (checkbox.independant){
            nextLocation = {
                pathname: '../job-independant',
                state: { d: d }
            }
        }else if (checkbox.etudiant){
            nextLocation = {
                pathname: '../job-student',
                state: { d: d }
            }
        }else if (d && hasPartner) {
            nextLocation = {
                pathname: '../job-partner',
                state: { d: d }
            }
        }else {
            nextLocation = {
                pathname: '../circumstances',
                state: { d: d }
            }
        }
        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const prevLocation = {
        pathname: '../family',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }

    // set control value and name to classic inputs using the custom Hook useInput
    const {value: Field31SituationAutreDetail, bind: bindField31SituationAutreDetail, reset: resetField31SituationAutreDetail } = useInput('');
    const {value: Sincefield31SituationAutre, bind: bindSincefield31SituationAutre, reset: resetSincefield31SituationAutre } = useInput('');
    const {value: Sinceouvrier, bind: bindSinceouvrier, reset: resetSinceouvrier } = useInput('');
    const {value: Sinceemploye, bind: bindSinceemploye, reset: resetSinceemploye } = useInput('');
    const {value: Sinceindependant, bind: bindSinceindependant, reset: resetSinceindependant } = useInput('');
    const {value: Sinceetudiant, bind: bindSinceetudiant, reset: resetSinceetudiant } = useInput('');
    const {value: Sincefonctionnaire, bind: bindSincefonctionnaire, reset: resetSincefonctionnaire } = useInput('');
    const {value: Sincepensionne, bind: bindSincepensionne, reset: resetSincepensionne } = useInput('');
    const {value: Sinceprepensionne, bind: bindSinceprepensionne, reset: resetSinceprepensionne } = useInput('');
    const {value: Sincedemandeur, bind: bindSincedemandeur, reset: resetSincedemandeur } = useInput('');
    const {value: Sincemutualite, bind: bindSincemutualite, reset: resetSincemutualite } = useInput('');
    const {value: Sincecpas, bind: bindSincecpas, reset: resetSincecpas } = useInput('');
    const {value: Sincesansprofession, bind: bindSincesansprofession, reset: resetSincesansprofession } = useInput('');

    // checkbox input custom handleChange
    const [checkbox, setCheckbox] = useState({
        ouvrier : '',
        employe : '',
        independant : '',
        etudiant : '',
        fonctionnaire : '',
        pensionne : '',
        prepensionne : '',
        demandeur : '',
        mutualite : '',
        cpas : '',
        sansprofession : '',
        field31SituationAutre : ''
    });

    const handleChangeCheckbox = (e) => {
        const item = e.target.name;
        const isChecked = e.target.checked;
        let partialChecked = {...checkbox}
        partialChecked[item] = isChecked
        setCheckbox( partialChecked )

    }

    const [stored, setStored] =  useState("")

    useEffect(() => {
        window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);

            const job = JSON.parse(localStorage.getItem('job'))

            if (job){
                setStored(true)
                !!job.Field31SituationAutreDetail && resetField31SituationAutreDetail(job.Field31SituationAutreDetail)
                !!job.Sinceouvrier && resetSinceouvrier(job.Sinceouvrier)
                !!job.Sinceemploye && resetSinceemploye(job.Sinceemploye)
                !!job.Sinceindependant && resetSinceindependant(job.Sinceindependant)
                !!job.Sinceetudiant && resetSinceetudiant(job.Sinceetudiant)
                !!job.Sincefonctionnaire && resetSincefonctionnaire(job.Sincefonctionnaire)
                !!job.Sincepensionne && resetSincepensionne(job.Sincepensionne)
                !!job.Sinceprepensionne && resetSinceprepensionne(job.Sinceprepensionne)
                !!job.Sincedemandeur && resetSincedemandeur(job.Sincedemandeur)
                !!job.Sincemutualite && resetSincemutualite(job.Sincemutualite)
                !!job.Sincecpas && resetSincecpas(job.Sincecpas)
                !!job.Sincesansprofession && resetSincesansprofession(job.Sincesansprofession)
                !!job.Sincefield31SituationAutre && resetSincefield31SituationAutre(job.Sincefield31SituationAutre)
                setCheckbox(job.checkbox)
            }
        };
        fetchData()
    }, []);


    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

        window.scrollTo(0, 0)

        //console.log(checkbox)
        evt.preventDefault();
        let notValid = !checkbox
        if (!!checkbox){
            notValid = ( !checkbox.field31SituationAutre && !checkbox.ouvrier && !checkbox.employe && !checkbox.independant && !checkbox.etudiant && !checkbox.fonctionnaire && !checkbox.pensionne && !checkbox.prepensionne && !checkbox.demandeur && !checkbox.mutualite && !checkbox.cpas && !checkbox.sansprofession && !checkbox.field31SituationAutre) ||

                (checkbox.ouvrier && !Sinceouvrier)||
                (checkbox.employe && !Sinceemploye)||
                (checkbox.independant && !Sinceindependant)||
                (checkbox.etudiant && !Sinceetudiant)||
                (checkbox.fonctionnaire && !Sincefonctionnaire)||
                (checkbox.pensionne && !Sincepensionne)||
                (checkbox.prepensionne && !Sinceprepensionne)||
                (checkbox.demandeur && !Sincedemandeur)||
                (checkbox.mutualite && !!Sincemutualite)||
                (checkbox.cpas && !Sincecpas)||
                (checkbox.sansprofession && !Sincesansprofession)||
                (checkbox.field31SituationAutre && !Sincefield31SituationAutre) ||
                (checkbox.field31SituationAutre && !Field31SituationAutreDetail)

            //console.log(Sincesansprofession)
            setNotValid(notValid)
        }
        if (!notValid){
            let job = {
                checkbox :checkbox,
                Field31SituationAutreDetail : Field31SituationAutreDetail,
                Sinceouvrier : Sinceouvrier,
                Sinceemploye : Sinceemploye,
                Sinceindependant : Sinceindependant,
                Sinceetudiant : Sinceetudiant,
                Sincefonctionnaire : Sincefonctionnaire,
                Sincepensionne : Sincepensionne,
                Sinceprepensionne : Sinceprepensionne,
                Sincedemandeur : Sincedemandeur,
                Sincemutualite : Sincemutualite,
                Sincecpas : Sincecpas,
                Sincesansprofession : Sincesansprofession,
                Sincefield31SituationAutre : Sincefield31SituationAutre
            }
            //let stringInfo = JSON.stringify(job)
            let stringInfo = serialize(job, {isJSON: true});
            localStorage.setItem("job" , stringInfo)
            //console.log(JSON.parse(stringInfo))
            next()
        }

    }



    const { i18n } = useTranslation();
    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
                    <BreadCrumb n={4}/>
                    <Row>
                        <Col>

                            <h3>{ d ? i18n.t("JOBTITLEDEATH"): i18n.t("JOBTITLE")  }</h3>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">
                                    <FormGroup check>
                                        <Label for="checkbox" className={(NotValid) ? "text-danger" : "text"}>{ !!d ?  i18n.t("field31SituationDeath") : i18n.t("field31Situation")  } <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="ouvrier" onChange={handleChangeCheckbox} value="ouvrier"  checked={!!checkbox.ouvrier ? checkbox.ouvrier : '' } />
                                                {  i18n.t("ouvrier") }
                                            </Label>
                                        </div>
                                        { !!checkbox.ouvrier && checkbox.ouvrier &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sinceouvrier">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSinceouvrier} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.ouvrier && !Sinceouvrier ) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="employe" onChange={handleChangeCheckbox} value="employe"  checked={!!checkbox.employe ? checkbox.employe : '' } />
                                                {  i18n.t("employe") }
                                            </Label>
                                        </div>
                                        { !!checkbox.employe && checkbox.employe &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sinceemploye">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSinceemploye} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.employe && !Sinceemploye ) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="independant" onChange={handleChangeCheckbox} value="independant"  checked={!!checkbox.independant ? checkbox.independant : '' } />
                                                {  i18n.t("independant") }
                                            </Label>
                                        </div>
                                        { !!checkbox.independant && checkbox.independant &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sinceindependant">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSinceindependant} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.independant && !Sinceindependant ) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="etudiant" onChange={handleChangeCheckbox} value="etudiant"  checked={!!checkbox.etudiant ? checkbox.etudiant : '' } />
                                                {  i18n.t("etudiant") }
                                            </Label>
                                        </div>
                                        { !!checkbox.etudiant && checkbox.etudiant &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sinceetudiant">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSinceetudiant} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.etudiant && !Sinceetudiant ) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="fonctionnaire" onChange={handleChangeCheckbox} value="fonctionnaire"  checked={!!checkbox.fonctionnaire ? checkbox.fonctionnaire : '' } />
                                                {  i18n.t("fonctionnaire") }
                                            </Label>
                                        </div>
                                        { !!checkbox.fonctionnaire && checkbox.fonctionnaire &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sincefonctionnaire">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSincefonctionnaire} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.fonctionnaire && !Sincefonctionnaire) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="pensionne" onChange={handleChangeCheckbox} value="pensionne"  checked={!!checkbox.pensionne ? checkbox.pensionne : '' } />
                                                {  i18n.t("pensionne") }
                                            </Label>
                                        </div>
                                        { !!checkbox.pensionne && checkbox.pensionne &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sincepensionne">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSincepensionne} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.pensionne && !Sincepensionne) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="prepensionne" onChange={handleChangeCheckbox} value="prepensionne"  checked={!!checkbox.prepensionne ? checkbox.prepensionne : '' } />
                                                {  i18n.t("prepensionne") }
                                            </Label>
                                        </div>
                                        { !!checkbox.prepensionne && checkbox.prepensionne &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sinceprepensionne">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSinceprepensionne} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.prepensionne && !Sinceprepensionne ) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="demandeur" onChange={handleChangeCheckbox} value="demandeur"  checked={!!checkbox.demandeur ? checkbox.demandeur : '' } />
                                                {  i18n.t("demandeur") }
                                            </Label>
                                        </div>
                                        { !!checkbox.demandeur && checkbox.demandeur &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sincedemandeur">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSincedemandeur} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.demandeur && !Sincedemandeur ) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="mutualite" onChange={handleChangeCheckbox} value="mutualite"  checked={!!checkbox.mutualite ? checkbox.mutualite : '' } />
                                                {  i18n.t("mutualite") }
                                            </Label>
                                        </div>
                                        { !!checkbox.mutualite && checkbox.mutualite &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sincemutualite">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSincemutualite} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.mutualite && !!Sincemutualite && Sincemutualite === "") ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="cpas" onChange={handleChangeCheckbox} value="cpas"  checked={!!checkbox.cpas ? checkbox.cpas : '' } />
                                                {  i18n.t("cpas") }
                                            </Label>
                                        </div>
                                        { !!checkbox.cpas && checkbox.cpas &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sincecpas">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSincecpas} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.cpas && !Sincecpas) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="sansprofession" onChange={handleChangeCheckbox} value="sansprofession"  checked={!!checkbox.sansprofession ? checkbox.sansprofession : '' } />
                                                {  i18n.t("sansprofession") }
                                            </Label>
                                        </div>
                                        { !!checkbox.sansprofession && checkbox.sansprofession &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sincesansprofession">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSincesansprofession} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.sansprofession && !Sincesansprofession) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field31SituationAutre" value="field31SituationAutre"  onChange={handleChangeCheckbox} checked={!!checkbox.field31SituationAutre ? checkbox.field31SituationAutre : '' } />
                                                {  i18n.t("field31SituationAutre") }
                                            </Label>
                                        </div>
                                        { !!checkbox.field31SituationAutre &&

                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label for="Sincefield31SituationAutre">{  i18n.t("beginDate") }? <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindSincefield31SituationAutre} className="form-control"  placeholder={i18n.t("année") } invalid={(NotValid && checkbox.field31SituationAutre && !Sincefield31SituationAutre) ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="field31SituationAutreDetail">{  i18n.t("field31SituationAutreDetail") } <span className={"text-danger"}>*</span></Label>
                                                <Input type="textarea" maxLength={5000} {...bindField31SituationAutreDetail} className="form-control"  placeholder={i18n.t("placeholderfield31SituationAutreDetail") } invalid={(NotValid && Field31SituationAutreDetail === "") ? true : undefined}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>

                                        </div>
                                        }
                                    </FormGroup>

                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                </div>

                            </Form>

                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default Job

